
module.directive('issueBadge', function($animate, IssueService) {
    return {
        restrict: 'E',
        template: "<span class='badge count-{{ count }}'>{{ count || ''}}</span>",
        scope: {
            model: '=',
            name: '@',
            count: '=?'
        },
        link: function(scope, element, attrs) {
            if (attrs.model) {
                var issues = IssueService.getIssues(scope.model.$model_name,
                                                    scope.model.id);
                var names = scope.name.split(',');

                scope.$watch(function() {
                    return names.reduce(function(total, name) {
                        return total + (issues[name] || 0);
                    }, 0);
                }, function(newCount, oldCount) {
                    animateBadge($animate, scope, element, newCount, oldCount);
                });
            }
        }
    };
});


function animateBadge($animate, scope, element, newCount, oldCount) {
    if (oldCount !== newCount || angular.isUndefined(scope.count)) {
        if (newCount === 0) {
            $animate.addClass(element, "zero").then(function() {
                scope.count = newCount;
            });
        } else if (oldCount === 0) {
            scope.count = newCount;
            $animate.removeClass(element, "zero");
        } else {
            $animate.addClass(element, "pulse").then(function() {
                scope.count = newCount;
                $animate.removeClass(element, "pulse");
            });
        }
    }
}

